import React from 'react';
import { View, Text, StyleSheet, ScrollView } from 'react-native';
import { FontAwesome5 } from '@expo/vector-icons';

interface Props {
  reservationInfo: any;
}

const DeliveryDetails = ({ reservationInfo }: Props) => {
  // Extract relevant information from reservationInfo
  const deliveredBy = reservationInfo?.driverDeliveredBy || 'N/A';
  const pickedUpBy = reservationInfo?.driverPickedUpBy || 'N/A';
  const deliveryDate = new Date(reservationInfo?.start_date).toLocaleDateString() || 'N/A';
  const deliveryAddress = reservationInfo.use_manual? reservationInfo.manual_address: (reservationInfo?.all_addresses?.number??'') + ' ' + (reservationInfo?.all_addresses?.street??'') + ' ' + (reservationInfo?.all_addresses?.property_name??'') + ' ' + (reservationInfo?.all_addresses?.plantation??'');

  const renderInfoRow = (label: string, value: string, icon?: string) => (
    <View style={styles.infoRow}>
      <View style={styles.labelContainer}>
        {icon && <FontAwesome5 name={icon} size={16} color="#666" style={styles.icon} />}
        <Text style={styles.label}>{label}:</Text>
      </View>
      <Text style={styles.value}>{value}</Text>
    </View>
  );

  const renderSection = (title: string, children: React.ReactNode, icon?: string) => (
    <View style={styles.section}>
      <View style={styles.sectionHeader}>
        {icon && <FontAwesome5 name={icon} size={18} color="#333" style={styles.sectionIcon} />}
        <Text style={styles.sectionTitle}>{title}</Text>
      </View>
      <View style={styles.sectionContent}>
        {children}
      </View>
    </View>
  );

  return (
    <View style={styles.container}>
      <ScrollView 
        style={styles.scrollView}
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        {/* Delivery Details */}
        {renderSection(
          'Delivery Details',
          <>
            {renderInfoRow('Delivered By', deliveredBy, 'user')}
            {renderInfoRow('Picked Up By', pickedUpBy, 'user-check')}
            {renderInfoRow('Delivery Date', deliveryDate, 'calendar')}
            {renderInfoRow('Delivery Address', deliveryAddress, 'map-marker-alt')}
          </>,
          'truck'
        )}

        {/* Additional Notes */}
        {/* {notes && renderSection(
          'Delivery Notes',
          <Text style={styles.notesText}>{notes}</Text>,
          'sticky-note'
        )} */}
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#f8f9fa',
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    padding: 20,
    paddingBottom: 40,
  },
  section: {
    backgroundColor: 'white',
    borderRadius: 12,
    marginBottom: 16,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 2,
  },
  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  sectionIcon: {
    marginRight: 10,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: '#333',
  },
  sectionContent: {
    padding: 20,
  },
  infoRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 16,
    minHeight: 24,
  },
  labelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    marginRight: 16,
  },
  icon: {
    marginRight: 8,
    width: 16,
  },
  label: {
    fontSize: 16,
    fontWeight: '500',
    color: '#666',
    flex: 1,
  },
  value: {
    fontSize: 16,
    color: '#333',
    fontWeight: '400',
    flex: 1,
    textAlign: 'right',
  },
  notesText: {
    fontSize: 16,
    color: '#333',
    lineHeight: 24,
    fontStyle: 'italic',
  },
});

export default DeliveryDetails;